import React from "react";
import "../assets/css/info.css";

const InfoPage: React.FC = () => {
  return (
    <div className="info-wrapper">
      <h1>Procedura Penali</h1>
      <p>
        sennder Italia S.r.l. (c.f./p.i. 10933700964) con sede legale a 20125,
        Milano (MI) - Via Arbe 49, 20125, Milano, in persona del legale
        rappresentante pro tempore (di seguito “sennder”) e il vettore (di
        seguito il “Vettore” e congiuntamente le “Parti”) convengono che le
        seguenti disposizioni integrano e non sostituiscono i “ TERMINI &amp;
        CONDIZIONI GENERALI - VETTORI ” consultabili{" "}
        <a
          href="https://www.sennder.com/it/terms-conditions/carrier"
          target="_blank"
          rel="noreferrer"
        >
          qui
        </a>
        . In caso di esecuzione dell’Ordine di Trasporto da parte del Vettore
        all’interno del network avente come punto di origine e/o di destino un
        hub/filiale di Poste Italiane S.p.a o di SDA Express Courier S.p.a. o
        di un cliente di Poste Italiane S.p.a. o di SDA Express Courier S.p.a.
        (di seguito il “Network Postale”), l’inosservanza di uno o più degli
        obblighi indicati all’interno dei TERMINI E CONDIZIONI GENERALI PER I
        SERVIZI DI TRASPORTO - VETTORI comporterà l’applicazione del
        corrispondente importo a titolo di penale.
      </p>
      <h1>Manuale</h1>
      <p>
        Il Manuale per la Gestione dei Disservizi rinvenibile a{" "}
        <a
          href="https://hidrive.ionos.com/lnk/YVakAIl6K#file"
          target="_blank"
          rel="noreferrer"
          style={{ textDecoration: "underline" }}
        >
          questo link
        </a>{" "}
        serve come linea guida per poter trasmettere giustificativi idonei,
        migliorare la qualità dei documenti allegati e velocizzare il processo
        della gestione delle potenziali penali.
      </p>
      <h1>Dati</h1>
      <p>
        Il Vettore è tenuto al rispetto delle istruzioni riguardanti il
        trasporto che pervengano per iscritto da sennder o dal destinatario,
        con particolare riferimento alle date di carico e scarico, alla
        compilazione dei documenti accompagnatori al trasporto (quale, a titolo
        esemplificativo ma non esaustivo, la lettera di vettura), nonché
        all&#39;esecuzione dell&#39;Ordine di Trasporto. Il Vettore è tenuto
        inoltre al controllo della correttezza dei dati/orari rilasciati sul
        foglio di corsa e/o lettera di vettura e/o polizza di carico e/o
        documento di trasporto. Il Vettore sarà responsabile di qualsiasi danno
        e/o spesa derivante dall&#39;omessa e/o parziale e/o non corretta
        esecuzione di tali obblighi e dovrà indennizzare sennder a prima
        richiesta a seguito di qualsivoglia pretesa e/o sanzione rivolta o
        comminata nei confronti di sennder.
      </p>

      <h1>Tempistiche</h1>
      <p>
        sennder Italia S.r.l., nel caso in cui rilevi un disservizio dovuto a
        ritardo in posizionamento, partenza o percorrenza riferito ad una delle
        linee comprese nel "Network Postale", procederà alla segnalazione della
        applicanda penale al vettore. Nel caso in cui il vettore sia in grado
        di comprovare, tramite idonea documentazione (il cui elenco è
        consultabile all’interno del documento
        <a
          href="https://hidrive.ionos.com/lnk/YVakAIl6K#file"
          target="_blank"
          rel="noreferrer"
        >
          “Manuale per la gestione dei disservizi”
        </a>
        ), di trovarsi in una delle casistiche che prevedono la non
        applicazione della penale, quest&#39;ultimo sarà tenuto a compilare gli
        appositi campi e ad inserire le ragioni del ritardo, procedendo a
        fornire il giustificativo stesso entro 7 (sette) giorni dalla
        segnalazione di sennder.
      </p>
      <p>Laddove:</p>
      <ul>
        <li>
          siano trascorsi 7 giorni (sette) dalla segnalazione senza che il
          giustificativo sia stato fornito (costituendo tale casistica
          un&#39;accettazione a tutti gli effetti della penale da parte del
          vettore), ovvero;
        </li>
        <li>
          il giustificativo sia stato fornito entro il termine di 7 giorni
          (sette) dalla segnalazione, ma le osservazioni in esso contenute e
          formulate dal Vettore/Trazionista risultino mancanti, errate e/o
          infondate;
        </li>
      </ul>
      <p>
        sennder Italia S.r.l. procederà con l’effettiva applicazione della
        penale al Vettore/Trazionista ed al relativo addebito della stessa.
      </p>

      <h1>Richiesta di pagamento</h1>
      <p>
        sennder Italia S.r.l. per ciascun servizio di trasporto in relazione al
        quale è prevista l’applicazione di una penale, provvederà all&#39;invio
        di una Richiesta preliminare di Pagamento (o RDP) contenente le linee
        oggetto di disservizio, le date di esecuzione delle linee e
        l&#39;ammontare relativo alla penale, calcolato come segue:
      </p>

      <p>
        <b>Penali per ritardo di posizionamento, partenza e percorrenza</b>:
        l’importo della penale è calcolato come percentuale (%) sul totale del
        prezzo dell’arco, così come definito all’interno dei Termini e
        Condizioni Generali - Vettore;
      </p>

      <p>
        <b>
          Penali per mancata esecuzione del servizio di trasporto senza
          preavviso di 24h rispetto all&#39;orario di inizio
        </b>
        : l’importo della penale è calcolato come percentuale (%) sul totale
        del compenso pattuito per il trasporto, così come definito all’interno
        dei Termini e Condizioni Generali - Vettori;
      </p>

      <p>
        <b>Penali per mancanza di dispositivi tecnici di sicurezza</b>:
        l’importo della penale è calcolato come somma totale degli importi
        definiti all’interno dei Termini e Condizioni Generali - Vettori per
        mancanza di ciascun tipo di dispositivi tecnici di sicurezza;
      </p>

      <p>
        <b>Penali per mancato tracciamento GPS</b>: l’importo della penale per
        ogni Ordine di Trasporto non tracciato interamente con GPS è calcolato
        come da importi definiti all’interno dei Termini e Condizioni Generali
        - Vettori.
      </p>

      <p>
        La Richiesta di Pagamento contiene i dati anagrafici del Vettore (quali
        ragione sociale, partita IVA o codice fiscale, sede legale etc),
        l&#39;indicazione del numero seriale di documento e la data di
        emissione del documento.
      </p>
      <p>
        Gli importi indicati nelle Richieste di Pagamento non vengono indicati
        nel Riepilogo Ordini. Le somme dovute a titolo di penale non sono
        soggette ad applicazione di IVA ai sensi dell’art. 15 comma 1 n. 1)
        D.P.R. 633/1972.
      </p>
      <p>
        Le somme dovute a titolo di penale prevedono l&#39;applicazione
        dell’imposta di bollo pari ad €2,00 euro per singolo documento, così
        come specificato dall’art. 15 comma 1 n. 1) D.P.R. 633/1972 e dalla
        R.M. Entrate n. 64 del 23/04/2004.
      </p>
      <p>
        Le richieste di pagamento vengono sottratte e/o detratte e/o compensate
        al momento del pagamento.
      </p>
      <p>
        In caso di ulteriori domande, è possibile contattare l&#39;indirizzo{" "}
        <a href="mailto:penali@sennder.it">penali@sennder.it</a>
      </p>
    </div>
  );
};

export default InfoPage;
